import React, { FC, useCallback, useMemo } from 'react'
import { Button, Table } from '@wmgtech/legato'
import { ColumnsType } from '@wmgtech/legato/build/components/Table/types'

import { formatMatchSearch } from 'modulesCommon/Notifications/utils/notifications'

import { ProductMatchNotificationsProps } from './ProductMatchNotifications.props'
import { TNotifications } from '../../types'

import './ProductMatchNotifications.scss'

const ProductMatchNotifications: FC<ProductMatchNotificationsProps> = ({ data, onViewProduct }) => {
  const onViewProductHandler = useCallback(
    (notification) => onViewProduct(formatMatchSearch(notification)),
    [onViewProduct]
  )

  const columns = useMemo<ColumnsType<TNotifications>[]>(
    () => [
      {
        dataIndex: 'artist',
        key: 'artist',
        title: 'Artist',
        sortable: false,
        render: (record, item) => <>{item.product?.campaign?.artist?.name}</>
      },
      {
        dataIndex: 'product',
        key: 'product',
        title: 'Product',
        sortable: false,
        render: (record, item) => <>{item.product?.name}</>
      },
      {
        dataIndex: 'status',
        key: 'status',
        title: 'Status',
        sortable: false,
        render: (record, notification) => {
          const onClick = () => onViewProductHandler(notification)

          return <Button containerStyle="outline" colorType="secondary-black" label="View" onClick={onClick} />
        }
      }
    ],
    [onViewProductHandler]
  )

  return (
    <div>
      <div className="notifications__header">
        <h2 className="notifications__title">Product Match</h2>
      </div>
      <div className="notifications__content product-match-notifications__content">
        <Table
          className="product-match-notifications__content-table"
          rowKey={(record: TNotifications, index) => `${record.id ?? index}`}
          columns={columns}
          data={data}
          pagination={false}
          condensed
        />
        <div className="notifications-info notifications-info--wide">
          <h3 className="notifications__title">Product Match</h3>
          At Storybox, we pride ourselves on quickly and accurately matching products with the correct projects. To do
          this, we search the WMG database daily for new products. We prompt the user to look closer when a potential
          match is found. If it is a match, click "assign," and the product will be added. Ignore the prompt if it's not
          a match, and you will be notified if/when a new match is found. This system helps us to ensure that every
          product finds the perfect story!
        </div>
      </div>
    </div>
  )
}

export default ProductMatchNotifications
